import { render, staticRenderFns } from "./ListaFluxo.vue?vue&type=template&id=4bcbd010&scoped=true&"
import script from "./ListaFluxo.vue?vue&type=script&lang=js&"
export * from "./ListaFluxo.vue?vue&type=script&lang=js&"
import style0 from "./ListaFluxo.vue?vue&type=style&index=0&id=4bcbd010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbd010",
  null
  
)

export default component.exports